module.exports = __webpack_public_path__ + "img/qrcode.37e07fdd.jpeg";